import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid } from 'semantic-ui-react'
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import renderHTML from 'react-render-html';
import { getPrivacy } from "../../store/OrderRedux";
import { Config } from "../../common"
import { StarButton } from '../../components'

const PrivacypolicyScreen = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token)
    const privacy = useSelector((state) => state.order.privacy)

    useEffect(() => {
        dispatch(getPrivacy({ token }));
        window.scrollTo(0, 0)
    }, []);

    let newItem = privacy ? Config.GetLanguage(privacy, i18n.language, 'data') : {}
    let title = newItem.heading
    return (
        <>
            <div className="container_bg clearall">
                <div className="Conditions">
                    {title && (<h4>{(title).split(' ')[0]} <span> {title.substring(title.indexOf(" ") + 1, title?.length)}</span></h4>)}
                </div>
                <div className="updates">
                    {renderHTML(newItem.text || "<p></p>")}
                    <h6>{moment.utc(privacy?.createdAt).format('Do MMM YYYY')}</h6>
                </div>
                <Grid centered columns={16} >
                    <Grid.Row>
                        <div className="conditionbt">
                            <StarButton background={'mainBg'} title={t("tremcondition.btn")} onClickAction={() => history.push('/')} />
                        </div>
                    </Grid.Row>
                </Grid>

            </div>



        </>
    );
};



export default PrivacypolicyScreen;
